'use strict';

var _ = require('lodash');
var PooledSeasonalityIndexAnalysisChartDirective = function PooledSeasonalityIndexAnalysisChartDirective() {
  return {
    restrict: 'E',
    template: require('../templates/pooled-seasonality-index-analysis-chart.html'),
    controller: 'PooledSeasonalityIndexAnalysisChartController',
    scope: {
      cabinClassGroups: '=',
      indexRtps: '=',
      indexDowGroups: '=',
      screenState: '=',
      displayedCalendar: '='
    },
    link: function link(scope) {
      scope.indexCabins = _.keys(scope.cabinClassGroups);
      scope.indexClassGroups = scope.getClassGroupsPerCabin(scope.indexCabins[0]);
      scope.init();
    }
  };
};
PooledSeasonalityIndexAnalysisChartDirective.$inject = [];
module.exports = PooledSeasonalityIndexAnalysisChartDirective;